/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const ClearIndicator = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.ClearIndicator;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

ClearIndicator.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      ClearIndicator: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

ClearIndicator.defaultProps = {
  selectProps: {
    custom: {
      ClearIndicator: null,
    },
  },
  children: null,
};

export default ClearIndicator;
